var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from "moment";
import { createForm } from "rc-form";
import { withFormItem } from 'fe-toolkit';
import { GroupInput } from '@components';
import { AccountBusiness } from '@business/account/login';
import classnames from 'classnames';
import { Loader } from 'oned';
import { formatPhone, sendAmplitude_Otp } from '@common/utils';
import { AmplitudeEventName } from '@common/enums';
var FormInput = withFormItem(GroupInput);
var defaultValue = {
    phoneNumber: '',
    isLoading: false,
    errorMsg: ''
};
var SendOTP = /** @class */ (function (_super) {
    __extends(SendOTP, _super);
    function SendOTP(props) {
        var _this = _super.call(this, props) || this;
        _this.sendOtp = function () {
            var _a = _this.props, getResidentDetailByPhone = _a.getResidentDetailByPhone, sendOtpToPhone = _a.sendOtpToPhone, form = _a.form, history = _a.history, clientInfo = _a.clientInfo;
            var _b = _this.state, isLoading = _b.isLoading, phoneNumber = _b.phoneNumber;
            var jumpTime = 5000;
            form.validateFields({ force: true }, function (errors) {
                if (errors) {
                    var instance = form.getFieldInstance(Object.keys(errors)[0]);
                    instance.focus && instance.focus();
                    return;
                }
                _this.setState({ isLoading: true });
                var formattedPhone = phoneNumber.replace(/\D/g, "");
                var encodedPhone = btoa(formattedPhone); //base 64encoded phone
                getResidentDetailByPhone(formattedPhone).then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var request, otpResponse;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(data !== undefined && data.isSuccess && data.residentId !== undefined)) return [3 /*break*/, 2];
                                request = {
                                    phone: formattedPhone,
                                    clientCode: '',
                                    isPhoneEncrypted: false,
                                    residentId: data.residentId,
                                    eventId: data.eventId
                                };
                                return [4 /*yield*/, sendOtpToPhone(request)];
                            case 1:
                                otpResponse = _a.sent();
                                if (otpResponse !== undefined && otpResponse.isSuccess) {
                                    history.push("/account/verifyOtp?contact=" + encodedPhone + "&residentId=" + data.residentId + "&eventId=" + data.eventId);
                                    sendAmplitude_Otp(this.props.residentInfo, AmplitudeEventName.OTP_Transition_PhoneContinue_To_Verify);
                                }
                                else {
                                    this.setState({ isLoading: false, errorMsg: 'Cannot send OTP. Please try again.' });
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                this.setState({ isLoading: false });
                                history.push("/account/verifyLocation?contact=" + encodedPhone + "&eventId=" + data.eventId);
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }).catch(function (error) {
                    console.log(error);
                });
            });
        };
        _this.state = defaultValue;
        return _this;
    }
    SendOTP.prototype.componentDidMount = function () {
        var getClientInfo = this.props.getClientInfo;
        getClientInfo();
        sendAmplitude_Otp(this.props.residentInfo, AmplitudeEventName.OTP_Click_Entry);
    };
    SendOTP.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        var _a = this.state, phoneNumber = _a.phoneNumber, isLoading = _a.isLoading;
        return React.createElement(React.Fragment, null,
            React.createElement(Loader, { visible: isLoading, page: true }),
            React.createElement("div", { className: "login-flex" },
                React.createElement("div", { className: "login-page" },
                    React.createElement("div", { className: "customer-logo" }),
                    React.createElement("div", { className: "login-box", id: "step1" },
                        React.createElement("h5", { className: "text-left mt-2", style: { display: phoneNumber.length >= 10 ? 'none' : '' } }, "Please verify your account with the one time code sent to your phone"),
                        React.createElement("h5", { className: "text-left mt-2", style: { display: phoneNumber.length < 10 ? 'none' : '' } }, "A verfication code will be sent to your phone after you click \"Continue\""),
                        React.createElement("div", { className: "panel-body" },
                            React.createElement("div", { className: "form-group" },
                                React.createElement(FormInput, { value: (phoneNumber || phoneNumber === '') ? formatPhone("" + phoneNumber) : null, onChange: function (val) {
                                        val.length < 15 ? _this.setState({ phoneNumber: val }) : '';
                                    }, prop: "phoneNumber", label: "Please use the phone number on file", format: true, inputMode: "numeric", rules: [{ required: true, message: 'This field is required' }], form: form, placeholder: "(123) 456 7890" })),
                            this.state.errorMsg && React.createElement("p", { style: { marginTop: '-1rem' } },
                                React.createElement("i", { className: "help-block text-danger" }, this.state.errorMsg)),
                            React.createElement("a", { href: "javascript:void(0)", className: classnames("btn btn-submit btn-block", this.state.phoneNumber.length < 14 && 'disabled'), id: "sendOtp", onClick: function () {
                                    _this.sendOtp();
                                    sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_PhoneContinue);
                                } }, "Continue"),
                            React.createElement("div", { className: "form-group", style: { textAlign: 'center', marginTop: '5%' } },
                                React.createElement(Link, { to: "/account/verifyOtpError", className: "forgot-link", onClick: function () {
                                        sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_CantFindMYPhone);
                                    } }, "I can't find my phone number. Contact Us")))),
                    React.createElement("p", { className: "text-muted text-center" },
                        "\u00A9 ",
                        moment().utc().year(),
                        " Lessen, LLC. All Rights Reserved."))));
    };
    SendOTP = __decorate([
        createForm(),
        inject(AccountBusiness),
        observer
    ], SendOTP);
    return SendOTP;
}(React.Component));
export default SendOTP;
